module.exports = __webpack_public_path__ + "img/help6.e0381876.png";